// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { FaFacebook, FaInstagram, FaTwitter, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Kothari Luggage Mall</h3>
          <p>Maharashtra's premier destination for premium luggage and travel accessories since 1982.</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#brands">Brands</a></li>
            <li><a href="#categories">Categories</a></li>
            <li><a href="#hot-picks">Hot Picks</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <ul className="contact-info">
            <li><FaMapMarkerAlt /> Utility Center, Opposite Rajiv Gandhi Bhavan, Nashik</li>
            <li><FaPhone /> +91 1234567890</li>
            <li><FaEnvelope /> info@kothariluggagemall.com</li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="#"><FaFacebook /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Kothari Luggage Mall. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;